import { Table } from "antd";
import "./styles.scss";
import useVerticalSchedular from "./useVerticalSchedular";

const VerticalSchedular = ({
  events: unprocessedEvents,
  resources,
  handleDropFromOutsideCb,
  handleDropOnEventCb,
  handleInnerDropCb,
  handleResizeEventCb,
  handleResourceDropCb,
  calendarDate,
  facilityId,
  isBoardRunner,
  components,
  handleSelectSlot,
  handleSelectEvent,
  timeInterval = 60,
  allowSlotOverlap = false,
  timezone,
  startHourInView,
  autoScroll = false,
  allowDropOnSchedular,
  providerProps,
  handleUpdateRooms,
  isDropDownActive,
  selectedFacility,
  handleRefreshProvidersList,
}) => {
  const {
    calendarContainerRef,
    mainColumnHeaders,
    roomNameHeaders,
    childColumns,
    tableData,
  } = useVerticalSchedular({
    autoScroll,
    resources,
    unprocessedEvents,
    components,
    handleDropOnEventCb,
    providers: providerProps?.providers,
    allowDropOnSchedular,
    handleResourceDropCb,
    isDropDownActive,
    boardDate: calendarDate,
    facilityId,
    selectedFacility,
    handleRefreshProvidersList,
    isBoardRunner,
    providerProps,
  });

  return (
    <div className="v-schedular" ref={calendarContainerRef}>
      <Table
        columns={mainColumnHeaders}
        dataSource={tableData}
        rowKey="key"
        pagination={false}
        tableLayout="fixed"
        rowClassName={(record) =>
          record.isBoardRunnerRow ? "boardrunner-row" : "room-row"
        }
        expandable={{
          expandedRowRender: (sectionRecord) => {
            if (sectionRecord.isBoardRunnerRow) return null; // no expand for boardrunner row
            const dataWithSection = (sectionRecord.data || [])?.map((item) => ({
              ...item,
              section: sectionRecord.section,
              provider:
                sectionRecord.provider || item.provider || "Provider Name",
            }));

            return (
              <Table
                columns={childColumns}
                dataSource={dataWithSection}
                rowKey={(record) => record.id}
                pagination={false}
                showHeader={false}
                tableLayout="fixed"
                bordered
                rowClassName="case-row"
                onRow={(record) => ({
                  onClick: () => {
                    if (!record?.isEmpty) handleSelectEvent?.(record);
                  },
                })}
              />
            );
          },
          rowExpandable: (sectionRecord) =>
            !sectionRecord.isBoardRunnerRow && sectionRecord?.data?.length > 0,
          defaultExpandAllRows: true,
        }}
      />
    </div>
  );
};

export default VerticalSchedular;
